import TemplatedContent from './templated-content';

export default TemplatedContent;
